export enum BlocksPaymentMethod {
  CreditCard = 'PAY_BY_CARD',
  BankTransfer = 'BANK_TRANSFER',
  DirectDebit = 'DIRECT_DEBIT',
}
